import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
SubscriptionService.$inject = ["API_URL", "$http", "jwtHelper"];
angular.module('userApp').service('SubscriptionService', SubscriptionService);

function SubscriptionService(API_URL, $http, jwtHelper) {
  // The purpose of this function is to update the JWT token in the client
  // if necessary
  this.checkSubscription =
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2() {
    var token, payload, subscription;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            token = localStorage.getItem('jwt-token'), payload = jwtHelper.decodeToken(token);
            subscription = payload || null;

            try {
              setTimeout(
              /*#__PURE__*/
              // Make this a non-blocking call
              _asyncToGenerator(
              /*#__PURE__*/
              _regeneratorRuntime.mark(function _callee() {
                var _ref3, data;

                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return $http.get(API_URL + '/api/v1/subscriptions/validate', {
                          subscription: subscription
                        });

                      case 2:
                        _ref3 = _context.sent;
                        data = _ref3.data;

                      case 4:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, this);
              })), 0);
            } catch (err) {
              console.error("Error checking subscription: ".concat(err.message));
            }

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));
}